import { OfficialServices } from './OfficialServices'
import { PocServices } from './PocServices'

/**
 * Services Tab
 * Displays both Official and POC services in separate tables
 */
const Services = () => {
    return (
        <div className="space-y-2">
            <OfficialServices />
            <PocServices />
        </div>
    )
}

export default Services
